import { render } from "./Password.vue?vue&type=template&id=7b57572e&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"

import "./Password.vue?vue&type=style&index=0&id=7b57572e&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b57572e"]])

export default __exports__